export default function confirm(desc = '確認操作', title = '提示', confirmButtonName = '確定', cancelButtonName = '取消', distinguishCancelAndClose = false) {
    return this.$confirm(desc, title, {
        confirmButtonText: confirmButtonName,
        cancelButtonText: cancelButtonName,
        distinguishCancelAndClose,
        closeOnClickModal: false,
        type: 'warning',
        center: true,
    });
}
